import clsx from 'clsx';
import { titleize, dedasherize } from '@/utils/strings';
import styles from './styles.module.scss';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

const SharedWidgetTagList = _ref => {
  let {
    tags = [],
    keyPrefix,
    variant: srcVariant,
    className
  } = _ref;
  const variants = Array.isArray(srcVariant) ? srcVariant : [srcVariant];
  const variantClasses = variants.map(variant => styles[`list--${variant}`]);
  return /*#__PURE__*/_jsx("ul", {
    className: clsx(styles.list, ...variantClasses, className),
    children: tags.map(tag => /*#__PURE__*/_jsxs("li", {
      className: styles.item,
      children: [variants.includes('hashtag') ? '#' : '', titleize(dedasherize(tag))]
    }, `${keyPrefix}-${tag}`))
  });
};

export default SharedWidgetTagList;